import { Title } from '@angular/platform-browser';
import { EsoService, DecisionTreeRule } from './../eso.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-decision-tree',
    templateUrl: './decision-tree.component.html',
    styleUrls: ['./decision-tree.component.scss'],
    standalone: false
})
export class DecisionTreeComponent implements OnInit {
  esoDecisionTreeRules: DecisionTreeRule[] = [];
  currentlySelectedRuleIds: number[] = [];

  adjustments: string[] = ['Safety Stock', 'Service Level'];
  currentlySelectedAdjustment: string;
  ruleToBeDeleted: DecisionTreeRule;

  showPopup = false;
  infoPopupMessage = '';
  showInfoPopup = false;

  changesWereMade = false;

  constructor(
    private esoService: EsoService,
    private ref: ChangeDetectorRef,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle("Eso Decision Tree");

    this.getData();
  }

  getData() {
    const $this = this;
    this.esoDecisionTreeRules = [];
    this.currentlySelectedRuleIds = [];

    this.esoService
      .getDecisionTreeData()
      .subscribe((result) => {
        result.forEach((element) => {
          if (element.decisionTrees.length > 0) {
            if (element.serviceLevelAdj) {
              element.selectedAdjustment = this.adjustments[1];
            } else {
              element.selectedAdjustment = this.adjustments[0];
            }

            element.stocks = [];
            element.stocks.push({
              DataName: "asIs",
              DataValue: element.decisionTrees[0].stockValueStatus,
            });
            element.stocks.push({
              DataName: "current",
              DataValue: element.decisionTrees[0].stockValueStatus,
            });
            element.stocks.push({
              DataName: "target",
              DataValue: element.decisionTrees[0].stockValueFinal,
            });
            $this.esoDecisionTreeRules.push(element);
          }
        });

        this.esoDecisionTreeRules.sort((a, b) => a.ruleOrder - b.ruleOrder);
        $this.currentlySelectedRuleIds.push(
          $this.esoDecisionTreeRules[0].ruleId
        );

      },
        (error) => {
          console.error(error);
        });

    console.log(this.esoDecisionTreeRules);
  }

  addRuleToSelectedList(ruleId: number) {
    if (!this.currentlySelectedRuleIds.includes(ruleId)) {
      this.currentlySelectedRuleIds.push(ruleId);
    } else {
      this.currentlySelectedRuleIds = this.currentlySelectedRuleIds.filter(x => x !== ruleId);
    }

    this.ref.detectChanges();
  }

  addDecisionTreeRuleAfterCurrent(ruleId: number) {
    const currentRule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);

    this.esoService
      .createNewDecisionTree(currentRule.ruleOrder + 1)
      .subscribe((result) => {
        this.showInfoPopup = false;

        this.infoPopupMessage = "";

        this.getData();
      },
        (error) => {


          console.error(error);
        });
  }

  saveSingleDecisionTreeRule(ruleId: number) {
    const data: DecisionTreeRule[] = [];
    const currentlySavedRule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    data.push(currentlySavedRule);


    this.esoService
      .updateDecisionTreeList(data)
      .subscribe((result) => {
        this.showInfoPopup = true;
        this.infoPopupMessage =
          "Decision Tree List has been succesfully updated!";

        this.changesWereMade = false;
      },
        (error) => {


          console.error(error);
        });
  }

  saveAllChanges() {

    this.esoService
      .updateDecisionTreeList(this.esoDecisionTreeRules)
      .subscribe((result) => {
        this.showInfoPopup = true;
        this.infoPopupMessage =
          "Decision Tree List has been succesfully updated!";

        this.changesWereMade = false;
      },
        (error) => {


          console.error(error);
        });
  }

  deleteDecisionTreeRule(ruleId: number) {

    this.showPopup = false;

    this.esoService
      .deleteDecisionTreeRule(ruleId)
      .subscribe((result) => {
        const deletedRule = this.esoDecisionTreeRules.find(
          (x) => x.ruleId === ruleId
        );

        this.currentlySelectedRuleIds = this.currentlySelectedRuleIds.filter(
          (x) => x !== ruleId
        );
        this.esoDecisionTreeRules = this.esoDecisionTreeRules.filter(
          (x) => x.ruleId !== ruleId
        );
        this.esoDecisionTreeRules
          .filter((x) => x.ruleOrder >= deletedRule.ruleOrder)
          .forEach((x) => (x.ruleOrder = x.ruleOrder - 1));

        this.showInfoPopup = true;
        this.infoPopupMessage =
          "Decision Tree Rule has been succesfully deleted!";

      },
        (error) => {


          console.error(error);
        });
  }

  increaseCurrentRuleOrder(ruleId: number) {
    const currentRule = this.esoDecisionTreeRules.find(rule => rule.ruleId === ruleId);

    if (currentRule.ruleOrder < 2) {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'Rule is already at 1st position!';
    } else {
      const currentRuleIndex = this.esoDecisionTreeRules.indexOf(currentRule);

      const tmp = this.esoDecisionTreeRules[currentRuleIndex - 1].ruleOrder;
      this.esoDecisionTreeRules[currentRuleIndex - 1].ruleOrder = this.esoDecisionTreeRules[currentRuleIndex].ruleOrder;
      this.esoDecisionTreeRules[currentRuleIndex].ruleOrder = tmp;

      this.esoDecisionTreeRules.sort((a, b) => a.ruleOrder - b.ruleOrder);
      this.changesWereMade = true;
    }
  }

  decreaseCurrentRuleOrder(ruleId: number) {
    const currentRule = this.esoDecisionTreeRules.find(rule => rule.ruleId === ruleId);
    let index = this.esoDecisionTreeRules.findIndex(rule => rule.ruleId === ruleId);
    let IsLastElement = false;
    if (index != null && index == this.esoDecisionTreeRules.length - 1) {
      IsLastElement = true;
    }
    if (IsLastElement) {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'Rule is already at last position!';
    } else {
      const currentRuleIndex = this.esoDecisionTreeRules.indexOf(currentRule);
      const tmp = this.esoDecisionTreeRules[currentRuleIndex + 1].ruleOrder;
      this.esoDecisionTreeRules[currentRuleIndex + 1].ruleOrder = this.esoDecisionTreeRules[currentRuleIndex].ruleOrder;
      this.esoDecisionTreeRules[currentRuleIndex].ruleOrder = tmp;

      this.esoDecisionTreeRules.sort((a, b) => a.ruleOrder - b.ruleOrder);
      this.changesWereMade = true;
    }
  }

  runDecisionTreeUpdate() {

    this.esoService
      .runDecisionTreeUpdate()
      .subscribe((result) => {

        this.changesWereMade = false;
        this.getData();
      },
        (error) => {


          console.error(error);
        });
  }

  showDeletePopup(ruleId: number) {
    this.ruleToBeDeleted = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    this.showPopup = true;
  }

  changeInfoPopupStatus() {
    this.showInfoPopup = !this.showInfoPopup;
    this.infoPopupMessage = '';
  }

  // Control events for DevExpress
  onTreeNameChanged(e, ruleId: number) {
    const rule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    rule.decisionTrees[0].decisionTreeName = e.value;
    this.changesWereMade = true;
  }

  onAdjustmentChanged(e, ruleId: number) {
    const rule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);

    if (e.value === this.adjustments[0]) {
      rule.serviceLevelAdj = false;
    } else {
      rule.serviceLevelAdj = true;
    }

    this.changesWereMade = true;
  }

  onJoinChanged(e, ruleId: number) {
    const rule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    rule.ruleJoin = e.value;
    this.changesWereMade = true;
  }

  onWhereChanged(e, ruleId: number) {
    const rule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    rule.ruleWhere = e.value;
    this.changesWereMade = true;
  }

  onValidActionChanged(e, ruleId: number) {
    const rule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    rule.validationAction = e.value;
    this.changesWereMade = true;
  }

  onRuleAdjDescChanged(e, ruleId: number) {
    const rule = this.esoDecisionTreeRules.find(x => x.ruleId === ruleId);
    rule.adjustmentDescription = e.value;
    this.changesWereMade = true;
  }

  onLegendClick(e: any) {
    const series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
  }
}
